import type { FC } from 'react';
import React, { useCallback } from 'react';

import { FullscreenIcon } from '../../assets/FullscreenIcon';
import { Tooltip } from '../Tooltip/Tooltip';
import { ICON_SIZE_MAP } from '../../../constants';

import styles from './FullscreenToggle.module.scss';

interface FullscreenToggleProps {
  size: 'medium' | 'large';
  isFullscreen: boolean;
  onEnterFullscreen: () => void;
  onExitFullscreen: () => void;
}

export const FullscreenToggle: FC<FullscreenToggleProps> = ({
  size,
  isFullscreen,
  onEnterFullscreen,
  onExitFullscreen,
}) => {
  const iconSize = ICON_SIZE_MAP[size];
  const tooltipContent = 'Full Screen';
  const ariaLabel = isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen';

  const handleFullscreenToggle = useCallback(() => {
    if (isFullscreen) {
      return onExitFullscreen();
    }

    return onEnterFullscreen();
  }, [isFullscreen, onEnterFullscreen, onExitFullscreen]);

  return (
    <Tooltip content={tooltipContent}>
      <button
        className={styles.button}
        type="button"
        tabIndex={0}
        aria-label={ariaLabel}
        onClick={handleFullscreenToggle}
      >
        <FullscreenIcon width={iconSize} height={iconSize} />
      </button>
    </Tooltip>
  );
};
